export const config = [
  {
    label: "School",
    type: "select",
    placeholder: "Select a school",
    required: true,
    options: "option1",
  },
  {
    label: "Grade",
    type: "select",
    placeholder: "Select a Grade",
    required: true,
    options: "option2",
  },
  {
    label: "Event",
    type: "select",
    placeholder: "Select a Event",
    required: false,
    options: "option3",
  },
];
export const eventsjson = [
  {
    date: "12 Jun",
    events: [
      {
        name: "Score",
        level: "prilims",
        round: "Round 1",
        time: "10:00AM-01:00PM",
      },
      {
        name: "HotsOlympaid",
        level: "prilims",
        round: "Round 2",
        time: "10:00AM-01:00PM",
      },
      {
        name: "HotsOlympaid",
        level: "prilims",
        round: "Round 2",
        time: "10:00AM-01:00PM",
      },
      {
        name: "HotsOlympaid",
        level: "prilims",
        round: "Round 2",
        time: "10:00AM-01:00PM",
      },
    ],
  },
  {
    date: "13 Jun",
    events: [
      {
        name: "MathOlympaid",
        level: "prilims",
        round: "Round 1",
        time: "10:00AM-01:00PM",
      },
      {
        name: "EnglishOlympaid",
        level: "prilims",
        round: "Round 2",
        time: "10:00AM-01:00PM",
      },
    ],
  },
  {
    date: "14 Jun",
    events: [
      {
        name: "MathOlympaid",
        level: "prilims",
        round: "Round 1",
        time: "10:00AM-01:00PM",
      },
      {
        name: "EnglishOlympaid",
        level: "prilims",
        round: "Round 2",
        time: "10:00AM-01:00PM",
      },
    ],
  },
];
